import { Navigate } from 'react-router-dom'
import { isLogin } from './isLogin'
import { FirstLoginRoute } from './FirstLoginRoute'

export const PrivateRoute = ({ children }) => {
  if (!isLogin()) return <Navigate to="/" />;
  return <FirstLoginRoute>{children}</FirstLoginRoute>;
};